
import aboutQuery from "@/apollo/queries/pages/about.gql";
import lenisScrollMixin from '@/mixins/lenisScrollMixin';
import previewModeMixin from '@/mixins/previewModeMixin';
import photoSwipeMixin from '@/mixins/photoSwipe';

export default {
  name: 'about',
  colorMode: 'light',
  mixins: [lenisScrollMixin, previewModeMixin, photoSwipeMixin],
  data() {
    return {
      about: null,
    };
  },
  async asyncData({app, store}) {
    const previewMode = store.state.previewMode;

    if (previewMode) {
      await app.apolloProvider.defaultClient.resetStore();
    }

    const responseAbout = await app.apolloProvider.defaultClient.query({
      query: aboutQuery,
      variables: {
        locale: app.i18n.locale || 'en',
      },
    }).catch((err) => {
      console.log(JSON.stringify(err, null, 2));
    });

    const about = responseAbout.data?.about;

    return {
      about,
      previewMode,
    };
  },
}
